class PageReadspeakerManager {
    button;
    toolbar;
    constructor() {
        this.button = document.querySelector('.js-PageReadspeakerBtn');
        this.toolbar = document.querySelector('.js-PageReadspeakerToolbar');
        if (!this.button || !this.toolbar)
            return;
        this.button.addEventListener('click', this.toggle);
        const observer = new MutationObserver(() => {
            const closeButton = this.toolbar.querySelector('.rsbtn_closer');
            if (!closeButton)
                return;
            closeButton.addEventListener('click', this.onClose);
            observer.disconnect();
        });
        observer.observe(this.toolbar, { childList: true, subtree: true });
    }
    toggle = () => {
        this.button.classList.toggle('Active');
        const active = this.button.classList.contains('Active');
        this.button.setAttribute('aria-expanded', active.toString());
        if (active) {
            this.start();
        }
        else {
            this.stop();
        }
    };
    async start() {
        this.toolbar.classList.remove('Hidden');
        this.toolbar.querySelector('.rsbtn_play')?.click?.();
    }
    stop() {
        this.toolbar.classList.add('Hidden');
        this.toolbar.querySelector('.rsbtn_closer')?.click?.();
    }
    onClose = () => {
        this.toolbar.classList.add('Hidden');
        this.button.classList.remove('Active');
        this.button.setAttribute('aria-expanded', 'false');
    };
}
const pageReadspeakerManager = new PageReadspeakerManager();
export { PageReadspeakerManager, pageReadspeakerManager };
